import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreatePruebaInformativaRequest extends CreateKeyValueRequest {
  domicilio!: string;
  informaSobre!: string;
  idUsuarioResponsable!: number;
  idTipoInterviniente!: number;
  idEstadoPrueba!: number;
  idExpediente!: number;
  idPersonaInformante!: number;
  fechaOficioConfronte!: string;        // Formato ISO 8601 (ej. "2025-06-07T00:00:00Z")
  fechaOficioRetirado!: string;
  fechaOficioDiligenciado!: string;
  fechaOficioContestado!: string;
  fechaVenceContestacion!: string;
}
